import { TranslateService } from '@ngx-translate/core';
import { CheckboxFilterControl, FilterGroup } from '@vendasta/va-filter2';

export function prependStatusFiltersSection(filters: FilterGroup, translateService: TranslateService) {
  filters?.prependSection(translateService.instant('FRONTEND.SALES_UI.STATUS'), [
    new CheckboxFilterControl('resubmitted', translateService.instant('FRONTEND.SALES_UI.RESUBMITTED'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.RESUBMITTED'),
      }),
    }),
    new CheckboxFilterControl('pending', translateService.instant('FRONTEND.SALES_UI.PENDING'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.PENDING'),
      }),
    }),
    new CheckboxFilterControl(
      'awaiting-customer-approval',
      translateService.instant('FRONTEND.SALES_UI.AWAITING_CUSTOMER_APPROVAL'),
      false,
      {
        appliedValueMapper: (name) => ({
          name,
          label: translateService.instant('FRONTEND.SALES_UI.AWAITING_CUSTOMER_APPROVAL'),
        }),
      },
    ),
    new CheckboxFilterControl('approved', translateService.instant('FRONTEND.SALES_UI.APPROVED'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.APPROVED'),
      }),
    }),
    new CheckboxFilterControl('processing', translateService.instant('FRONTEND.SALES_UI.PROCESSING'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.PROCESSING'),
      }),
    }),
    new CheckboxFilterControl(
      'activation-errors',
      translateService.instant('FRONTEND.SALES_UI.ACTIVATION_ERRORS'),
      false,
      {
        appliedValueMapper: (name) => ({
          name,
          label: translateService.instant('FRONTEND.SALES_UI.ACTIVATION_ERRORS'),
        }),
      },
    ),
    new CheckboxFilterControl('archived', translateService.instant('FRONTEND.SALES_UI.ARCHIVED'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.ARCHIVED'),
      }),
    }),
    new CheckboxFilterControl('activated', translateService.instant('FRONTEND.SALES_UI.ACTIVATED'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.ACTIVATED'),
      }),
    }),
    new CheckboxFilterControl('declined', translateService.instant('FRONTEND.SALES_UI.DECLINED'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.DECLINED'),
      }),
    }),
    new CheckboxFilterControl(
      'scheduled-activation',
      translateService.instant('FRONTEND.SALES_UI.SCHEDULED_ACTIVATION'),
      false,
      {
        appliedValueMapper: (name) => ({
          name,
          label: translateService.instant('FRONTEND.SALES_UI.SCHEDULED_ACTIVATION'),
        }),
      },
    ),
    new CheckboxFilterControl('drafted', translateService.instant('FRONTEND.SALES_UI.DRAFTED'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.DRAFTED'),
      }),
    }),
    new CheckboxFilterControl(
      'cancellation-requested',
      translateService.instant('FRONTEND.SALES_UI.CANCELLATION_REQUESTED'),
      false,
      {
        appliedValueMapper: (name) => ({
          name,
          label: translateService.instant('FRONTEND.SALES_UI.CANCELLATION_REQUESTED'),
        }),
      },
    ),
    new CheckboxFilterControl('cancelled', translateService.instant('FRONTEND.SALES_UI.CANCELLED'), false, {
      appliedValueMapper: (name) => ({
        name,
        label: translateService.instant('FRONTEND.SALES_UI.CANCELLED'),
      }),
    }),
  ]);
}
